import React from "react";

function Cover() {
  return (
    <div className="cover-container">
      <h1>
        <div className="name-letter">A</div>
        <div className="name-letter">m</div>
        <div className="name-letter">o</div>
        <div className="name-letter">d&nbsp;</div>

        <div className="name-letter">M</div>
        <div className="name-letter">a</div>
        <div className="name-letter">n</div>
        <div className="name-letter">j</div>
        <div className="name-letter">a</div>
        <div className="name-letter">r</div>
        <div className="name-letter">e</div>
        <div className="name-letter">k</div>
        <div className="name-letter">a</div>
        <div className="name-letter">r</div>
      </h1>
    </div>
  );
}

export default Cover;
